import React, { useEffect, useState } from "react";
import * as image from "../../resources/images";
import { useDispatch, useSelector } from "react-redux";
import { getHcfChallenges } from "../../redux/actions/APIs";
import { PATHS } from "../../utils";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const Challenges = ({ setPopupData }) => {
	const dispatch = useDispatch();
	const history = useHistory();

	const [isMyChoice, setIsMyChoice] = useState([]);

	const { defaultChildData,
		hcfData,
	} = useSelector((state) => state.collections);

	useEffect(() => {
		if (!hcfData) {
			dispatch(getHcfChallenges());
		}
	}, []);

	const showChallengesPlan = () => {
		// setTab("Challenges_Plan");
		// let hmfObj = {
		//     "HMF_CHALLENGES": isMyChoice
		// }
		// dispatch(postCoursesHcfPlan(defaultChildData?.id, hmfObj))
		history.push({
			pathname: PATHS.MYPLAN_PAGE,
			state: { type: "Challenges", getCourseIds: isMyChoice }
		});
	}

	const handleClickOnMyChoice = (choiceName) => {
		if (isMyChoice?.length >= 4 && !isMyChoice?.includes(choiceName)) {
			setPopupData({
				title: "Max Challenges Limit",
				message: "You have already selected the maximum(4) number of challenges.You can delete a challenge to add new challenge.",
			});
			return;
		}
		let myChoiceArr = [...isMyChoice];
		const key = myChoiceArr?.findIndex((chName) => chName === choiceName);
		if (key != -1) {
			myChoiceArr?.splice(key, 1)
		} else {
			myChoiceArr?.push(choiceName);
		}

		setIsMyChoice(myChoiceArr);
	}

	return (
		<div className="course_catalogfilstes mb-3">
			<h2>Is Your Child’s Behavior Bothering You? </h2>
			<p className="p2 lighttextcolor mt-3" >
				Is your child’s behaviour bothering and concerning you? Select 2-4 concerns and challenges you’re seeing, and we’ll build a custom Growth Plan just for them!
			</p>

			<div className="developmentarea">

				<div className="dimtagcontainer">
					<div className="lifeeventlist populattags Child_challenges">
						<ul>
							{hcfData?.records?.length > 0 &&
								hcfData?.records?.map((userChoice, index) => (
									<li className="" key={index}>
										<div className="Ansoptions">
											<label className="selAnslabel ">
												<p className="p1">{userChoice?.uiLable}</p>
												<input
													type="checkbox"
													id="option0"
													name="option0"
													checked={isMyChoice?.includes(
														userChoice?.uiLable
													)}
													onClick={() => handleClickOnMyChoice(userChoice?.uiLable)}
												/>
												<span class="checkmark"></span>
											</label>
										</div>
									</li>
								))}

							{/* <li className="">
                <div className="Ansoptions">
                  <label className="selAnslabel ">
                    <p className="">My Child Is Unaware Of Their Emotions</p>
                    <input type="checkbox" name="knowledgecheck" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </li>
              <li className="">
                <div className="Ansoptions">
                  <label className="selAnslabel ">
                    <p className="">My Child Cares Too Much About What Other People Think</p>
                    <input type="checkbox" name="knowledgecheck" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </li>
              <li className="">
                <div className="Ansoptions">
                  <label className="selAnslabel ">
                    <p className="">My Child Has Difficulty Outside Of Their Comfort Zone</p>
                    <input type="checkbox" name="knowledgecheck" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </li>
              <li className="">
                <div className="Ansoptions">
                  <label className="selAnslabel ">
                    <p className="">My Child Consistently Makes Poor Life Choices</p>
                    <input type="checkbox" name="knowledgecheck" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </li>
              <li className="">
                <div className="Ansoptions">
                  <label className="selAnslabel ">
                    <p className="">My Child Makes Excuses for their behaviour</p>
                    <input type="checkbox" name="knowledgecheck" />
                    <span class="checkmark"></span>
                  </label>
                </div>
              </li> */}

						</ul>
						<div className="buttonFooter pt-4 mt-3 text-right">
							<button className="mybutton" onClick={() => showChallengesPlan()}
								disabled={isMyChoice?.length < 2}><i className="fa-solid fa-paper-plane mr-1"></i>Recommend A Growth Plan</button>
						</div>

					</div>

				</div>
			</div>
		</div>
	);
}
export default Challenges;